module.exports = __webpack_public_path__ + "static/visual_3-35ec7441825fd1900090f725e4f92f69.jpg";